'use client'

import { ColumnDef } from '@tanstack/react-table'
import { TokenData } from '@/views/V3Info/types'
import { CurrencyLogo } from '@pancakeswap/widgets-internal'
import { createCurrentcy } from '@/utils/currency'
import { Address } from 'viem'
import { Typography } from '@/components/ui/typography'
import React from 'react'
import { formatDollarAmount } from '@/views/V3Info/utils/numbers'
import Percent from '@/views/V3Info/components/Percent'
import SortButton from '@/components/sort-button'

export const tokenColumns: ColumnDef<TokenData>[] = [
  {
    accessorKey: 'id',
    header: '#',
  },
  {
    id: 'name',
    sortDescFirst: true,
    accessorFn: (row) => row.name.toLowerCase(),
    header: ({ column }) => <SortButton<TokenData> name={'Name'} column={column} />,
    cell: ({ row }) => {
      return (
        <div className={'flex items-center gap-2'}>
          <CurrencyLogo currency={createCurrentcy(999, row.original.address as Address)} />
          <Typography>{row.original.name}</Typography>
          <Typography variant={'small'} className={'text-muted-foreground'}>
            {row.original.symbol}
          </Typography>
        </div>
      )
    },
  },
  {
    id: 'priceUSD',
    accessorFn: (row) => row.priceUSD,
    sortDescFirst: true,
    cell: ({ row }) => {
      return formatDollarAmount(row.original.priceUSD)
    },
    header: ({ column }) => <SortButton<TokenData> name={'Price'} column={column} />,
  },
  {
    id: 'priceChange',
    accessorFn: (row) => row.priceUSDChange,
    sortDescFirst: true,
    cell: ({ row }) => {
      return <Percent value={row.original.priceUSDChange} fontWeight={400} />
    },
    header: ({ column }) => <SortButton<TokenData> name={'Price Change'} column={column} />,
  },
  {
    id: 'volume24h',
    accessorFn: (row) => row.volumeUSD,
    sortDescFirst: true,
    cell: ({ row }) => {
      return formatDollarAmount(row.original.volumeUSD)
    },
    header: ({ column }) => <SortButton<TokenData> name={'Volume 24H'} column={column} />,
  },
  {
    id: 'tvl',
    accessorFn: (row) => row.tvlUSD,
    sortDescFirst: true,
    cell: ({ row }) => {
      return formatDollarAmount(row.original.tvlUSD)
    },
    header: ({ column }) => <SortButton<TokenData> name={'TVL'} column={column} />,
  },
]
